import { createActions, handleActions } from 'redux-actions';

import selectors from './selectors';

const initialState = {
  jobDesigns: {},
  selectedDesignId: null,
  isSavingDesign: false,
};

const RECEIVE_JOB_DESIGNS = 'DESIGN_PRO/JOB_DESIGNS/RECEIVE_JOB_DESIGNS';
const SAVE_DESIGN = 'DESIGN_PRO/JOB_DESIGNS/SAVE_DESIGN';
const SELECT_DESIGN = 'DESIGN_PRO/JOB_DESIGNS/SELECT_DESIGN';
const UPDATE_IS_SAVING_DESIGN =
  'DESIGN_PRO/JOB_DESIGNS/UPDATE_IS_SAVING_DESIGN';
const UPDATE_IS_SWITCHING_DESIGN =
  'DESIGN_PRO/JOB_DESIGNS/UPDATE_IS_SWITCHING_DESIGN';
const UPDATE_SELECTED_DESIGN_ID =
  'DESIGN_PRO/JOB_DESIGNS/UPDATE_SELECTED_DESIGN_ID';

const actions = createActions({
  [RECEIVE_JOB_DESIGNS]: (jobDesigns) => ({ jobDesigns }),
  [SAVE_DESIGN]: () => null,
  [SELECT_DESIGN]: (selectedDesignId) => ({ selectedDesignId }),
  [UPDATE_IS_SAVING_DESIGN]: (isSavingDesign) => ({ isSavingDesign }),
  [UPDATE_IS_SWITCHING_DESIGN]: (isSwitchingDesign) => ({ isSwitchingDesign }),
  [UPDATE_SELECTED_DESIGN_ID]: (selectedDesignId) => ({ selectedDesignId }),
});

const reducer = handleActions(
  {
    [actions.designPro.jobDesigns.receiveJobDesigns]: (state, action) => ({
      ...state,
      jobDesigns: action.payload.jobDesigns,
    }),
    [actions.designPro.jobDesigns.updateSelectedDesignId]: (state, action) => ({
      ...state,
      selectedDesignId: action.payload.selectedDesignId,
    }),
    [actions.designPro.jobDesigns.updateIsSavingDesign]: (state, action) => ({
      ...state,
      isSavingDesign: action.payload.isSavingDesign,
    }),
    [actions.designPro.jobDesigns.updateIsSwitchingDesign]: (
      state,
      action,
    ) => ({
      ...state,
      isSwitchingDesign: action.payload.isSwitchingDesign,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.jobDesigns,
  reducer,
  selectors,
};
